import React, { PropsWithChildren, ReactNode } from "react";

type Props = {
  condition: boolean;
  fallback?: ReactNode;
};

const RenderWhen: React.FC<PropsWithChildren<Props>> = ({
  children,
  condition,
  fallback = null
}) => (condition ? <>{children}</> : <>{fallback}</>);

export default RenderWhen;
